"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports._FakeIBAN = void 0;
exports._FakeIBAN = {
    accountHolder: 'fitpay payments',
    iban: 'DE02120300000000202051',
};
